import React from "react";

import { Notice, NOTICE_TYPES } from "@appcues/component-library";
import moment from "moment";

export const FrequencyCapBanner = props => {
  const { buffer, userProfile, navigateToAccount } = props;

  const flowSeenDuringFreqCap =
    buffer &&
    userProfile &&
    Date.now() - userProfile._lastContentShownAt < buffer;

  const formattedTime = moment(userProfile._lastContentShownAt)
    .add(buffer, "ms")
    .fromNow(true);

  if (flowSeenDuringFreqCap) {
    return (
      <Notice type={NOTICE_TYPES.warning}>
        Frequency capping is enabled on your account. This user will not see
        another flow for {formattedTime}. To change this go to your{" "}
        <a onClick={() => navigateToAccount()}>account settings</a>.
      </Notice>
    );
  }
  return null;
};
